<template>
    <section class="py-12 bg-gray-50 dark:bg-neutral-700" v-if="articles != null && articleShowingCount > 0 && !articlesLoading">
        <div class="container mx-auto">
            <div class="grid grid-cols-1 gap-5">
                <div class="mb-5 text-center">
                    <h3 class="mb-3 text-3xl text-gray-900 dark:text-gray-50">Articles and Learning resources </h3>
                    <p class="mb-5 text-gray-500 whitespace-pre-line dark:text-gray-300">Covering everything from how to land a job in the AI and web3 industry, to useful industry resources and the latest news.</p>
                </div>
            </div>
            <div class="grid grid-cols-12 gap-5">
                <!-- <div v-if="articlesLoading">
                    <img class="_imgLoader" src="@/assets/images/loading.gif" style="margin-bottom:800px"/>
                </div> -->
                <div class="col-span-12 md:col-span-6 lg:col-span-4"
                    v-bind:key="article" v-for="article in articles" >
                    <div class="p-5 mt-3 transition-all duration-500 bg-white hover:-translate-y-2 rounded shadow-lg shadow-gray-100/50 card dark:bg-neutral-800 dark:shadow-neutral-600/20 group/blog">
                          
                            <img @click="handleArtlicleClick(article.Slug, article.ResourceType)" 
                              v-lazy=article.MainImage 
                              style="height: 180px; cursor: pointer;" 
                              class="w-full rounded"/>

                            <a href="#" @click="handleArtlicleClick(article.Slug, article.ResourceType)" class="primary-link" style="cursor: pointer;">
                                <h5 class="mt-3 mb-1 text-gray-900 fs-17 dark:text-gray-50">{{ article.Title }}</h5>
                            </a>

                              <ul class="mb-3 list-inline" style="display: block;">
                                <li v-bind:key="category" v-for="category in article.Categories" style="display: inline-block; padding-top:5px">
                                  <span 
                                  class="px-1.5 py-0.5 mt-1 text-sm font-medium text-gray-700 rounded border p-[6px] border-gray-100/50 dark:text-gray-50"  
                                  style="border: 1px solid black; padding: 5px; font-size: 9pt; margin-right: 3px;" 
                                    :class="
                                    { 
                                      'active': this.tags.includes(category),  
                                      '': !this.tags.includes(category) 
                                    }" 
                                    v-on:click="handleCategoryClick(category)">
                                      <a>{{ category }}</a>
                                    </span>
                                </li>
                              </ul>
                            <p class="mb-3 text-gray-500 dark:text-gray-300">{{ article.Excerpt }}</p>
                            <a href="#" @click="handleArtlicleClick(article.Slug, article.ResourceType)" 
                            class="font-medium group-data-[theme-color=violet]:text-violet-500 group-data-[theme-color=sky]:text-sky-500 group-data-[theme-color=red]:text-red-500 group-data-[theme-color=green]:text-green-500 group-data-[theme-color=pink]:text-pink-500 group-data-[theme-color=blue]:text-blue-500">Read more <i class="align-middle mdi mdi-chevron-right"></i></a>
                        </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { useStatus } from "@/api/composables/status";
import { useErrorLogger } from "@/api/composables/errorLogging";
import { contentAPI } from "@/api/content";

const pageStatus = useStatus();
const log = useErrorLogger();

export default {
  props: ["tags"],
  components: {
  },
 
  data() {
    return {
      notification : {
        text : "",
        level : "",
      },
      queryTagName : this.$route.params.category,
      articles : null,      
      articleResultCount : 0,
      articleShowingCount : 0,
      search: {
        tags: [this.$route.params.category],
        workingStyle: 'Remote'
      }
    }
  },
  created()
  {
    this.handleSearchArticles();
  },
  computed: {
    
  },
  mounted() {
  },
  methods: {
    async handleArtlicleClick(articleName, resourceType){
      this.$router.push('/blog/' + resourceType + '/' + articleName + "/");
    },
    async handleSearchArticles() {
      this.articlesLoading = true;
      const result = await log.catchPromise(() =>
          pageStatus.observe(async () => {
            const result = await contentAPI.searchArticles(this.tags);
            this.articles = result.Results.slice(0, 3);
            this.articleResultCount = result.ResultCount;
            this.articleShowingCount = result.Results.length; 
            this.articlesLoading = false;
          })
        );
        if (!result.success) 
        {
          //this.articlesLoading = false;
          //this.notification = { text : result.data, level : "error" };        
        }
  },
  }
}
</script>